import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { REQUEST_LOGIN_CODE_MUTATION, LOGIN_MUTATION } from '../graphql';
import get from 'lodash.get';

export class LoginForm extends Component {
  state = {
    email: '',
    code: '',
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      email: nextProps.email || prevState.email || '',
      code: nextProps.code || prevState.code || '',
    };
  }

  componentDidMount() {
    const email = localStorage.getItem('email');
    if (email) this.setState({ email });
  }

  onSubmit = e => {
    e.preventDefault();

    const { requestLoginCode, login, tokenId } = this.props;
    const { email, code } = this.state;

    localStorage.setItem('email', email);

    if (!tokenId) requestLoginCode({ email });
    else login({ tokenId, email, code });
  };

  render() {
    const { requestLoginCodeLoading, requestLoginCodeError } = this.props;
    const { tokenId, loginLoading, loginError, loginData } = this.props;
    const { debug, reset } = this.props;

    const errorLoggingIn = loginError || get(loginData, 'login.error');

    return (
      <form className="form-signin" onSubmit={this.onSubmit}>
        <div className="form-group">
          <label htmlFor="inputEmail" className="">
            Email address
          </label>
          <input
            type="email"
            id="inputEmail"
            className={`form-control ${requestLoginCodeError && 'is-invalid'}`}
            placeholder="you@example.com"
            required={true}
            autoFocus={!requestLoginCodeLoading && !tokenId}
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })}
            disabled={requestLoginCodeLoading || !!tokenId}
          />
          <div className="invalid-feedback">{requestLoginCodeError}</div>
          <button
            className={`btn btn-lg ${
              !!tokenId ? 'btn-success' : 'btn-primary'
            } btn-block mt-1`}
            type={tokenId ? 'button' : 'submit'}
            disabled={requestLoginCodeLoading || !!tokenId}
          >
            {requestLoginCodeLoading
              ? 'Sending...'
              : tokenId ? '✅ Code Emailed' : 'Send Code'}
          </button>
        </div>
        {!!tokenId && (
          <div className="form-group">
            <hr />
            <label htmlFor="inputCode">Login Code </label>
            <input
              type="text"
              id="inputCode"
              className={`form-control ${errorLoggingIn && 'is-invalid'}`}
              placeholder="abc123"
              autoFocus={true}
              required={true}
              style={{ fontFamily: 'Monaco, monospace' }}
              value={this.state.code}
              onChange={e => this.setState({ code: e.target.value })}
              disabled={!!loginLoading}
              aria-describedby="codeHelpBlock"
            />
            {!errorLoggingIn && (
              <small id="codeHelpBlock" className="form-text text-muted">
                Check your email for the code.
              </small>
            )}
            <div className="invalid-feedback">{errorLoggingIn}</div>
            <button
              className="btn btn-lg btn-primary btn-block mt-1"
              type="submit"
              disabled={!!loginLoading}
            >
              {!!loginLoading ? 'Logging in...' : 'Log in'}
            </button>
            {errorLoggingIn && (
              <button
                className="btn btn-lg btn-secondary btn-block mt-1"
                type="button"
                onClick={() =>
                  alert(
                    'TODO: make this reset the form (for now, refresh the page)'
                  )
                }
              >
                Reset
              </button>
            )}
          </div>
        )}

        {debug && <pre>{JSON.stringify(this.props, null, 2)}</pre>}
      </form>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
LoginForm.propTypes = {
  email: PropTypes.string,
  code: PropTypes.string,
  tokenId: PropTypes.string,
  requestLoginCode: PropTypes.func.isRequired,
  requestLoginCodeLoading: PropTypes.bool,
  login: PropTypes.func.isRequired,
  loginLoading: PropTypes.bool,
};

export default props => (
  <Mutation mutation={REQUEST_LOGIN_CODE_MUTATION}>
    {(
      requestLoginCode,
      {
        loading: requestLoginCodeLoading,
        error: requestLoginCodeError,
        data: requestLoginCodeData,
      }
    ) => (
      <Mutation mutation={LOGIN_MUTATION}>
        {(
          login,
          { loading: loginLoading, error: loginError, data: loginData }
        ) => (
          <LoginForm
            {...props}
            tokenId={get(requestLoginCodeData, 'requestLoginCode.id')}
            requestLoginCode={({ email }) =>
              requestLoginCode({ variables: { email } })
            }
            requestLoginCodeLoading={requestLoginCodeLoading}
            requestLoginCodeData={requestLoginCodeData}
            requestLoginCodeError={get(requestLoginCodeError, 'message')}
            login={async ({ email, tokenId, code }) => {
              const res = await login({ variables: { email, code } });
              const payload = get(res, 'data.login');
              if (payload.token) props.onAuthentication(payload);
            }}
            loginLoading={loginLoading}
            loginData={loginData}
            loginError={get(loginError, 'message')}
          />
        )}
      </Mutation>
    )}
  </Mutation>
);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js